import React from 'react';
import PropTypes from 'prop-types';

import {
    Carousel,
} from 'reaxl';

import RecentSearchCard from './RecentSearchCard';
import SearchButton from './SearchButton';

function RecentSearches({
    buttonContext,
    carouselOptions = {},
    cellWidth = '261px',
    collapsed = false,
    data = [],
    maxWidth,
    onKeyDown,
    onNextButtonClick,
    onPrevButtonClick,
    onReady = () => { },
    onSettle = () => { },
    onStaticClick = () => { },
    uiContext = 'cards',
    buttonColor,
    buttonBorderColor,
    ...rest
}) {

    let Component;
    const searchCardProps = {
        onKeyDown,
    };

    switch (uiContext) {
        case 'cards': {
            Component = RecentSearchCard;
            searchCardProps.fullHeight = true;
            break;
        }

        default:
            searchCardProps.uiContext = buttonContext;
            searchCardProps.maxWidth = maxWidth;
            searchCardProps.buttonColor = buttonColor;
            searchCardProps.buttonBorderColor = buttonBorderColor;

            Component = SearchButton;
    }

    const searchCards = data.map((item, index) => (
        <Component
            key={'recentSearchCard-' + index}
            data={item}
            index={index}
            onClick={(event) => {
                onStaticClick(event, index);
            }}
            {...searchCardProps}
        />
    ));

    const isCardContext = uiContext === 'cards';
    const rootClassName = `recent-searches ${(!isCardContext && buttonContext !== 'trendingSearch') ? 'recent-searches-buttons' : ''}`;

    return (
        <div
            data-cmp="recentSearches"
            {...rest}
        >
            <Carousel
                className={rootClassName}
                initialIndex={0}
                onNextButtonClick={onNextButtonClick}
                onPrevButtonClick={onPrevButtonClick}
                onSettle={onSettle}
                onReady={onReady}
                lazyLoad={4}
                cellWidth={isCardContext && cellWidth}
                fullWidth={isCardContext}
                fullHeight
            >
                {searchCards}
            </Carousel>
        </div>
    );
}

RecentSearches.propTypes = {
    /**
     * array of recent search card objects
     */
    data: PropTypes.array,
    /**
    * button background color
    */
    buttonColor: PropTypes.string,
    /**
     * button border color
     */
    buttonBorderColor: PropTypes.string,
    /**
     * additional carousel options
     */
    carouselOptions: PropTypes.object,
    /**
     * if true, display mobile friendly view collapsing carousel prev/next buttons
     */
    collapsed: PropTypes.bool,
    /**
     * width of carousel in view
     */
    cellWidth: PropTypes.string,
    /**
     * The callback to handle events that will fire on static click
     */
    onStaticClick: PropTypes.func,
    /**
     * The callback to handle events that will fire on slide settle
     */
    onSettle: PropTypes.func,
    /**
     * The callback to handle events that will fire on carousel ready
     */
    onReady: PropTypes.func,
    /**
     * The callback to handle events that will fire on carousel ready
     */
    uiContext: PropTypes.oneOf([
        'cards',
        'buttons',
    ]),
};

export default RecentSearches;
